import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["billingCycle", "autoReplace", "autoReplaceWrapper", "manualExpirationDate"]
  static values = { housingOnly: Boolean }

  connect() {
    this.userOverrodeToggle = false

    if (this.housingOnlyValue) {
      if (this.hasBillingCycleTarget) {
        this.billingCycleTarget.value = "In-House"
        this.billingCycleTarget.disabled = true
      }
      if (this.hasAutoReplaceWrapperTarget) {
        this.autoReplaceWrapperTarget.classList.add('d-none')
      }
    }
  }

  billingCycleChanged() {
    if (this.hasManualExpirationDateTarget && this.hasBillingCycleTarget) {
      const disabled = this.billingCycleTarget.value !== "In-House"
      this.manualExpirationDateTarget.querySelectorAll("input").forEach((input) => { input.disabled = disabled })
    }

    if (!this.hasBillingCycleTarget || !this.hasAutoReplaceTarget) return

    const cycle = this.billingCycleTarget.value

    if (cycle === "In-House") {
      this.setAutoReplace(false, { auto: true })
    } else if (!this.userOverrodeToggle) {
      this.setAutoReplace(true, { auto: true })
    }
  }

  toggleChanged() {
    this.userOverrodeToggle = true
  }

  setAutoReplace(value, { auto = false } = {}) {
    if (!this.hasAutoReplaceTarget) return

    this.autoReplaceTarget.checked = value
    if (!auto) {
      this.userOverrodeToggle = true
    }
  }
}
